import _isNumber from "lodash/isNumber";
var FHA_LOAN_AMOUNT_THRESHOLD = 625500;
/**
 * Gets the percent of the yearly FHA Mortgage Insurance Premium
 * @see https://www.hud.gov/program_offices/housing/comp/premiums/annual_mip
 * @private
 * @param  {Number} loanAmount     The amount of the loanAmount
 * @param  {Number} loanTermMonths Loan term in months
 * @param  {Number} purchasePrice  Optional. Original purchase price of home
 * @return {Number}                MIP premium in decimal (e.g. 0.0085)
 */

export default (function (loanAmount, loanTermMonths, purchasePrice) {
  if (!_isNumber(purchasePrice)) {
    return 0.0085;
  } // LTV at the time of purchase


  var ltv = loanAmount / purchasePrice;

  if (loanTermMonths > 180) {
    if (loanAmount <= FHA_LOAN_AMOUNT_THRESHOLD) {
      return ltv <= 0.95 ? 0.008 : 0.0085;
    }

    return ltv <= 0.95 ? 0.01 : 0.0105;
  }

  if (loanAmount <= FHA_LOAN_AMOUNT_THRESHOLD) {
    return ltv <= 0.9 ? 0.0045 : 0.007;
  }

  if (ltv <= 0.78) {
    return 0.0045;
  }

  if (ltv > 0.9) {
    return 0.0095;
  }

  return 0.007;
});